import * as React from 'react';
import { SVGProps } from 'react';

const SvgBoxIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.932 3.327a2.446 2.446 0 0 1 2.442 0h.002l5.707 3.262c.302.174.562.41.764.691a.817.817 0 0 1 .203.338c.168.337.255.709.256 1.087v6.524a2.447 2.447 0 0 1-1.223 2.115l-.003.002-5.704 3.26h-.002c-.258.15-.541.25-.834.296a.811.811 0 0 1-.774 0 2.444 2.444 0 0 1-.835-.296h-.001l-5.704-3.26-.003-.002A2.447 2.447 0 0 1 4 15.23V8.705c0-.378.088-.75.256-1.087a.818.818 0 0 1 .203-.338c.202-.28.462-.517.764-.691l.003-.002 5.706-3.26Zm2.036 15.633 5.3-3.028a.816.816 0 0 0 .407-.705V9.144l-5.707 3.301v6.515Zm-1.63-6.515v6.515l-5.3-3.028h-.001a.816.816 0 0 1-.406-.705V9.144l5.707 3.301ZM12.56 4.74l5.267 3.01-5.675 3.283L6.478 7.75l5.264-3.008.003-.002a.815.815 0 0 1 .816 0Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgBoxIcon;
